import React from 'react';

export class DisasterResponseIcon extends React.PureComponent {
  render() {
    return (
      <svg width="77" height="60" viewBox="0 0 77 60" {...this.props}>
        <g fill="none" fillRule="evenodd">
          <path fill="#FFF" d="M38.685 6.8L70.77 45.46V59.2H6.602V45.46z" />
          <path fill="#2C3038" d="M37.451 18.523v39.385h2.468V18.523z" />
          <path
            d="M38.685 40.246a1.23 1.23 0 1 0-.935 2.034l14.793 17.225a1.236 1.236 0 0 0 2.174-.798l.01-17.23c0-.68-.553-1.23-1.234-1.23H38.685zm2.685 2.463h10.888l-.01 12.67-10.878-12.67zM34.995.861c-.481-.004-.921.27-1.127.704-.206.434-.14.947.168 1.316L74.47 52.989v5.701a1.23 1.23 0 0 0 .612 1.08c.385.224.86.224 1.244 0a1.23 1.23 0 0 0 .612-1.08v-6.139a1.23 1.23 0 0 0-.275-.77L35.954 1.339a1.235 1.235 0 0 0-.96-.477z"
            fill="#2C3038"
          />
          <path fill="currentColor" fillRule="nonzero" d="M26.346 27.938v7.385h2.467v-7.385z" />
          <path
            fill="currentColor"
            fillRule="nonzero"
            d="M23.878 30.4v2.462h7.403V30.4zM48.557 27.938v7.385h2.468v-7.385z"
          />
          <path fill="currentColor" fillRule="nonzero" d="M46.09 30.4v2.462h7.403V30.4z" />
          <path
            d="M42.34.863a1.235 1.235 0 0 0-.925.471L.702 51.781a1.23 1.23 0 0 0-.27.77v6.14a1.23 1.23 0 0 0 .612 1.08c.384.224.86.224 1.244 0a1.23 1.23 0 0 0 .612-1.08v-5.703l40.438-50.11c.31-.374.37-.895.155-1.33A1.235 1.235 0 0 0 42.34.863z"
            fill="#2C3038"
          />
          <path
            d="M6.602 44.548v14.154c0 .68.552 1.231 1.234 1.231h61.699c.681 0 1.234-.551 1.234-1.23V44.547H68.3v12.924H9.07V44.548H6.602z"
            fill="#2C3038"
          />
        </g>
      </svg>
    );
  }
}
